import { useSelector } from 'react-redux';

import { AemFeature } from '@app/components/AdobeExperienceFragments';
import { selectHasFiber } from '@app/redux';

interface CommonQuestionsFeatureMap {
  fiber: AemFeature;
  default: AemFeature;
}

export const useCommonQuestionsFeature = (features: CommonQuestionsFeatureMap): AemFeature => {
  const hasFiber = useSelector(selectHasFiber);
  return hasFiber ? features.fiber : features.default;
};
